module.exports = __webpack_public_path__ + "static/media/Ponche antigripal con té y fruta.7da76a5d.png";